(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["help-drawer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const drawer = document.getElementById('HelpDrawer');
    if (!drawer) return;

    const trigger = event.target.closest('[aria-controls="HelpDrawer"]');
    if (trigger) {
      const source = trigger.previousElementSibling;
      const target = drawer.querySelector('#created-div');
      if (source && target) target.innerHTML = source.innerHTML;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('help-drawer-open');
      return;
    }

    if (event.target.closest('[data-help-drawer-close]')) {
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('help-drawer-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const drawer = document.getElementById('HelpDrawer');
    if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;

    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('help-drawer-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  class HomeHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.slideshow = this.querySelector('slideshow-component');
      this.dots = Array.from(this.querySelectorAll('[data-home-hero-dot]'));
      this.pauseToggle = this.querySelector('[data-home-hero-pause]');
      this.reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.staticMode =
        this.dataset.static === 'true' || !this.slideshow || this.dots.length < 2 || this.reducedMotionMedia.matches;
      this.autoplayDelay = Number(this.dataset.autoplay) || 5000;
      this.activeIndex = Number(this.slideshow?.getAttribute('initial-slide')) || 0;
      this.activeSlide = null;
      this.autoplayTimer = null;
      this.currentAutoplayStart = 0;
      this.remainingAutoplayDelay = this.autoplayDelay;
      this.isInView = this.staticMode;
      this.isPaused = false;
      this.hasPosterBackedVideo = Boolean(this.querySelector('.home-hero-slide__video--with-poster'));
      this.posterVideoPlaybackAllowed = !this.hasPosterBackedVideo;
      this.videoPlaybackReady = document.readyState === 'complete';
      this.visibilityObserver = null;

      this.handleSlideSelect = this.handleSlideSelect.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handlePauseToggle = this.handlePauseToggle.bind(this);
      this.handleWindowLoad = this.handleWindowLoad.bind(this);
      this.allowPosterVideoPlayback = this.allowPosterVideoPlayback.bind(this);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.slideIndex);
          this.slideshow?.select(index, undefined, { animate: true });
        });
      });

      this.slideshow?.addEventListener('slideshow:select', this.handleSlideSelect);
      this.pauseToggle?.addEventListener('click', this.handlePauseToggle);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('load', this.handleWindowLoad, { once: true });

      if (this.hasPosterBackedVideo) {
        ['pointerenter', 'mouseover', 'pointerdown', 'touchstart', 'keydown', 'scroll'].forEach((eventName) => {
          window.addEventListener(eventName, this.allowPosterVideoPlayback, { once: true, passive: true });
        });
      }

      this.activeSlide = this.getSlideByIndex(this.activeIndex);
      this.updateUI(this.activeIndex);
      if (this.videoPlaybackReady) {
        this.scheduleVideoPlaybackSync();
      }

      if (!this.staticMode) {
        this.setupVisibilityObserver();
        this.bootstrapAutoplay();
      }
    }

    disconnectedCallback() {
      this.slideshow?.removeEventListener('slideshow:select', this.handleSlideSelect);
      this.pauseToggle?.removeEventListener('click', this.handlePauseToggle);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('load', this.handleWindowLoad);
      ['pointerenter', 'mouseover', 'pointerdown', 'touchstart', 'keydown', 'scroll'].forEach((eventName) => {
        window.removeEventListener(eventName, this.allowPosterVideoPlayback);
      });
      this.visibilityObserver?.disconnect();
      this.stopAutoplay();
    }

    handleWindowLoad() {
      this.videoPlaybackReady = true;
      this.scheduleVideoPlaybackSync();
    }

    allowPosterVideoPlayback() {
      this.posterVideoPlaybackAllowed = true;
      this.scheduleVideoPlaybackSync();
    }

    setupVisibilityObserver() {
      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;

          if (entry.isIntersecting) {
            this.isInView = entry.intersectionRatio >= 0.35;
            if (!document.hidden) {
              this.scheduleVideoPlaybackSync();

              if (this.isInView) {
                this.startAutoplay(this.remainingAutoplayDelay);
              }
            }
          } else {
            this.isInView = false;
            this.stopAutoplay({ preserveRemaining: true, pauseVisual: true });
          }
        },
        {
          threshold: [0, 0.35, 0.7],
        }
      );

      this.visibilityObserver.observe(this);
    }

    bootstrapAutoplay() {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);

      if (visibleHeight <= 0 || document.hidden) return;

      this.isInView = true;
      this.startAutoplay(this.remainingAutoplayDelay);
    }

    handleSlideSelect(event) {
      const nextIndex = Number(event.detail?.index) || 0;
      this.activeIndex = nextIndex;
      this.activeSlide = event.detail?.slide || this.getSlideByIndex(nextIndex);
      this.updateUI(nextIndex);
      this.scheduleVideoPlaybackSync();

      if (!this.staticMode && this.isInView && !document.hidden) {
        this.startAutoplay();
      }
    }

    scheduleVideoPlaybackSync() {
      if (!this.videoPlaybackReady) return;

      this.syncVideoPlayback();
      window.requestAnimationFrame(() => this.syncVideoPlayback());
      window.setTimeout(() => this.syncVideoPlayback(), 250);
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopAutoplay({ preserveRemaining: true, pauseVisual: true });
        return;
      }

      if (!this.staticMode && this.isInView && !this.isPaused) {
        this.scheduleVideoPlaybackSync();
        this.startAutoplay(this.remainingAutoplayDelay, { resume: true });
      }
    }

    handlePauseToggle() {
      if (this.staticMode) return;

      if (this.isPaused) {
        this.isPaused = false;
        this.pauseToggle?.setAttribute('aria-pressed', 'false');
        this.pauseToggle?.setAttribute('aria-label', 'Pause hero autoplay');
        if (this.isInView && !document.hidden) {
          this.scheduleVideoPlaybackSync();
          this.startAutoplay(this.remainingAutoplayDelay, { resume: true });
        }
      } else {
        this.isPaused = true;
        this.pauseToggle?.setAttribute('aria-pressed', 'true');
        this.pauseToggle?.setAttribute('aria-label', 'Resume hero autoplay');
        this.stopAutoplay({ preserveRemaining: true, pauseVisual: true });
      }
    }

    updateUI(activeIndex) {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
        dot.classList.remove('is-playing');

        const fill = dot.querySelector('.home-hero-slider__dot-fill');
        if (fill) {
          fill.style.animation = 'none';
          fill.style.animationPlayState = '';
          fill.style.animationDuration = '';
          void fill.offsetWidth;
        }
      });
    }

    getSlideByIndex(index) {
      const slides = Array.from(this.querySelectorAll(this.slideshow ? 'slideshow-slide' : '.home-hero-slide'));
      return slides[index] || null;
    }

    startAutoplay(delay = this.autoplayDelay, options = {}) {
      if (this.staticMode || !this.isInView || this.isPaused) return;

      const { resume = false } = options;
      this.stopAutoplay({ pauseVisual: resume });

      const activeDot = this.dots[this.activeIndex];
      const activeFill = activeDot?.querySelector('.home-hero-slider__dot-fill');
      if (activeDot && activeFill) {
        const canResume =
          resume &&
          activeDot.classList.contains('is-playing') &&
          window.getComputedStyle(activeFill).animationName !== 'none';

        if (canResume) {
          activeFill.style.animationPlayState = 'running';
        } else {
          activeFill.style.animation = 'none';
          activeFill.style.animationPlayState = '';
          void activeFill.offsetWidth;
          activeFill.style.animation = '';
          activeFill.style.animationDuration = `${delay}ms`;
        }

        activeDot.classList.add('is-playing');
      }

      this.currentAutoplayStart = window.performance.now();
      this.remainingAutoplayDelay = delay;
      this.autoplayTimer = window.setTimeout(() => {
        this.autoplayTimer = null;
        this.remainingAutoplayDelay = this.autoplayDelay;
        this.slideshow?.next();
      }, delay);
    }

    stopAutoplay(options = {}) {
      const { preserveRemaining = false, pauseVisual = false } = options;
      const activeDot = this.dots[this.activeIndex];
      const activeFill = activeDot?.querySelector('.home-hero-slider__dot-fill');

      if (preserveRemaining && this.autoplayTimer) {
        const elapsed = window.performance.now() - this.currentAutoplayStart;
        this.remainingAutoplayDelay = Math.max(0, this.remainingAutoplayDelay - elapsed);
      } else if (!preserveRemaining) {
        this.remainingAutoplayDelay = this.autoplayDelay;
      }

      if (pauseVisual && activeDot && activeFill) {
        activeDot.classList.add('is-playing');
        activeFill.style.animationPlayState = 'paused';
      } else {
        this.dots.forEach((dot) => dot.classList.remove('is-playing'));
        this.dots.forEach((dot) => {
          const fill = dot.querySelector('.home-hero-slider__dot-fill');
          if (fill) fill.style.animationPlayState = '';
        });
      }

      if (this.autoplayTimer) {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    syncVideoPlayback() {
      const slides = Array.from(this.querySelectorAll(this.slideshow ? 'slideshow-slide' : '.home-hero-slide'));
      const activeSlide = this.activeSlide || this.getSlideByIndex(this.activeIndex);

      slides.forEach((slide) => {
        const isActive = slide === activeSlide;
        const videos = Array.from(slide.querySelectorAll('video'));

        videos.forEach((video) => {
          const visible = video.offsetParent !== null;
          const isPosterBacked = video.classList.contains('home-hero-slide__video--with-poster');
          if (isActive && visible) {
            if (isPosterBacked && !this.posterVideoPlaybackAllowed) {
              video.pause();
              return;
            }

            video.autoplay = true;
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;

            video.querySelectorAll('source[data-src]').forEach((source) => {
              source.src = source.dataset.src;
              source.removeAttribute('data-src');
            });

            if (video.readyState === 0) {
              video.load();
            }

            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }

            if (video.readyState >= 2) {
              video.classList.add('is-ready');
            } else {
              video.addEventListener('canplay', () => video.classList.add('is-ready'), { once: true });
            }
          } else {
            video.pause();
          }
        });
      });
    }
  }

  if (!customElements.get('home-hero-slider')) {
    customElements.define('home-hero-slider', HomeHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-trust-bar"] && !Shopify.designMode) return;
  try {
    
  const initHomeTrustBarScrollHint = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-home-trust-bar]').forEach((section) => {
      const viewport = section.querySelector('[data-home-trust-bar-viewport]');
      if (!viewport || viewport.dataset.scrollHintInitialized === 'true') return;

      viewport.dataset.scrollHintInitialized = 'true';

      let userInteracted = false;
      let hasPlayed = false;

      const itemsOverflow = () => viewport.scrollWidth > viewport.clientWidth + 1;

      const markInteracted = () => {
        userInteracted = true;
      };

      viewport.addEventListener('pointerdown', markInteracted, { passive: true });
      viewport.addEventListener('wheel', markInteracted, { passive: true });
      viewport.addEventListener('touchstart', markInteracted, { passive: true });

      const animateScroll = (from, to, duration, onComplete) => {
        const startTime = performance.now();

        const step = (now) => {
          if (userInteracted) return;

          const progress = Math.min((now - startTime) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 3);
          viewport.scrollLeft = from + (to - from) * easedProgress;

          if (progress < 1) {
            requestAnimationFrame(step);
          } else if (onComplete) {
            onComplete();
          }
        };

        requestAnimationFrame(step);
      };

      const playHint = () => {
        if (hasPlayed || userInteracted || !itemsOverflow()) return;

        hasPlayed = true;
        const hintDistance = Math.min(96, viewport.scrollWidth - viewport.clientWidth);

        window.setTimeout(() => {
          if (userInteracted) return;
          animateScroll(0, hintDistance, 600, () => {
            window.setTimeout(() => {
              animateScroll(hintDistance, 0, 600);
            }, 300);
          });
        }, 350);
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.85 && itemsOverflow()) {
              playHint();
              observer.disconnect();
            }
          });
        },
        { threshold: [0.85] }
      );

      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeTrustBarScrollHint, { once: true });
  } else {
    initHomeTrustBarScrollHint();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  (() => {
    const CEREAL_COUNT = 1200;
    const VACUUM_RADIUS = 160;
    const VACUUM_WIDTH = 460;
    const VACUUM_HEIGHT = VACUUM_WIDTH * 0.725;
    const COLORS = ['#E8312A', '#F7931E', '#F9D72F', '#39B54A', '#1C75BC', '#9B59B6', '#E91E8C'];
    const desktopQuery = window.matchMedia('(min-width: 750px) and (pointer: fine)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const isBlocked = (x, y, zone) => x >= zone.x && x <= zone.x + zone.w && y >= zone.y && y <= zone.y + zone.h;

    const drawCereals = (ctx, cereals, vacuumed) => {
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      cereals.forEach((cereal) => {
        if (vacuumed.has(cereal.id)) return;

        const innerWidth = cereal.outerW * 0.4;
        const innerHeight = cereal.outerH * 0.4;

        ctx.save();
        ctx.translate(cereal.x, cereal.y);
        ctx.rotate(cereal.rotation);
        ctx.shadowColor = 'rgba(0,0,0,0.3)';
        ctx.shadowBlur = 2.5;
        ctx.shadowOffsetX = 0.5;
        ctx.shadowOffsetY = 1.5;
        ctx.beginPath();
        ctx.ellipse(0, 0, cereal.outerW / 2, cereal.outerH / 2, 0, 0, Math.PI * 2, false);
        ctx.ellipse(0, 0, innerWidth / 2, innerHeight / 2, 0, 0, Math.PI * 2, true);
        ctx.fillStyle = cereal.color;
        ctx.fill('evenodd');
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.beginPath();
        ctx.ellipse(0, -cereal.outerH * 0.14, cereal.outerW * 0.36, cereal.outerH * 0.17, 0, Math.PI, Math.PI * 2);
        ctx.strokeStyle = 'rgba(255,255,255,0.6)';
        ctx.lineWidth = 1.3;
        ctx.stroke();
        ctx.restore();
      });
    };

    const generateCereals = (width, height, safeZone) => {
      const idOffset = Date.now();

      return Array.from({ length: CEREAL_COUNT }, (_, index) => {
        const outerW = 18 + Math.random() * 11;
        let x = Math.random() * width;
        let y = Math.random() * height;

        for (let attempt = 0; attempt < 15 && isBlocked(x, y, safeZone); attempt += 1) {
          x = Math.random() * width;
          y = Math.random() * height;
        }

        if (isBlocked(x, y, safeZone)) {
          y = Math.random() < 0.5
            ? Math.random() * safeZone.y
            : safeZone.y + safeZone.h + Math.random() * Math.max(0, height - safeZone.y - safeZone.h);
        }

        return {
          id: idOffset + index,
          x,
          y,
          rotation: Math.random() * Math.PI * 2,
          outerW,
          outerH: outerW * (0.62 + Math.random() * 0.22),
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
        };
      });
    };

    document.querySelectorAll('[data-interactive-404]').forEach((section) => {
      const canvas = section.querySelector('[data-interactive-404-canvas]');
      const card = section.querySelector('[data-interactive-404-card]');
      const vacuum = section.querySelector('[data-interactive-404-vacuum]');
      const hint = section.querySelector('[data-interactive-404-hint]');
      const ctx = canvas?.getContext('2d');
      let cereals = [];
      let vacuumed = new Set();
      let active = false;
      let complete = false;
      let initialized = false;

      if (!canvas || !card || !vacuum || !ctx) return;

      const setCursor = (visible, event) => {
        if (!visible || !event) {
          vacuum.classList.remove('is-visible');
          return;
        }

        vacuum.style.left = `${event.clientX - VACUUM_WIDTH * 0.87}px`;
        vacuum.style.top = `${event.clientY - VACUUM_HEIGHT * 0.63}px`;
        vacuum.classList.add('is-visible');
      };

      const measureSafeZone = () => {
        const sectionRect = section.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const pad = 36;

        return {
          x: cardRect.left - sectionRect.left - pad,
          y: cardRect.top - sectionRect.top - pad,
          w: cardRect.width + pad * 2,
          h: cardRect.height + pad * 2,
        };
      };

      const initialize = () => {
        if (complete) {
          active = false;
          section.style.cursor = '';
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          setCursor(false);
          return;
        }

        active = desktopQuery.matches && !reduceMotion.matches;
        section.style.cursor = active ? 'none' : '';
        hint?.classList.toggle('is-visible', active);

        if (!active) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          setCursor(false);
          return;
        }

        const rect = section.getBoundingClientRect();
        const dpr = window.devicePixelRatio || 1;
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        vacuumed = new Set();
        cereals = generateCereals(rect.width, rect.height, measureSafeZone());
        drawCereals(ctx, cereals, vacuumed);
        initialized = true;
      };

      const resizeCanvas = () => {
        if (!initialized || !complete) {
          initialize();
          return;
        }

        active = false;
        section.style.cursor = '';
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        setCursor(false);
      };

      const onPointerMove = (event) => {
        if (!active || event.pointerType === 'touch') return;

        if (event.target instanceof Node && card.contains(event.target)) {
          setCursor(false);
          hint?.classList.remove('is-visible');
          return;
        }

        const rect = section.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        if (x < 0 || x > rect.width || y < 0 || y > rect.height) {
          setCursor(false);
          return;
        }

        setCursor(true, event);
        hint?.classList.remove('is-visible');

        const radiusSquared = VACUUM_RADIUS * VACUUM_RADIUS;
        let changed = false;

        cereals.forEach((cereal) => {
          if (vacuumed.has(cereal.id)) return;

          const dx = cereal.x - x;
          const dy = cereal.y - y;

          if (dx * dx + dy * dy < radiusSquared) {
            vacuumed.add(cereal.id);
            changed = true;
          }
        });

        if (!changed) return;

        drawCereals(ctx, cereals, vacuumed);

        if (vacuumed.size === cereals.length && !complete) {
          complete = true;
          active = false;
          section.style.cursor = '';
          setCursor(false);
        }
      };

      section.addEventListener('pointermove', onPointerMove);
      section.addEventListener('pointerleave', () => setCursor(false));
      window.addEventListener('resize', resizeCanvas);
      desktopQuery.addEventListener('change', initialize);
      reduceMotion.addEventListener('change', initialize);
      window.requestAnimationFrame(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  sessionStorage.removeItem('product-grid-view-mobile');

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-image-story"] && !Shopify.designMode) return;
  try {
    
  class ScrollImageStory extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-scroll-image-story-slide]'));
      this.media = Array.from(this.querySelectorAll('[data-scroll-image-story-media]'));
      this.dots = Array.from(this.querySelectorAll('[data-scroll-image-story-dot]'));
      this.track = this.querySelector('.scroll-image-story__track');
      this.sticky = this.querySelector('.scroll-image-story__sticky');
      this.raf = null;
      this.completed = false;
      this.handleScroll = this.requestUpdate.bind(this);
      this.handleResize = this.requestUpdate.bind(this);
      this.loadDeferredImages = this.loadDeferredImages.bind(this);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          if (!this.completed) return;

          this.complete();
          this.setActive(Number(dot.dataset.index));
        });
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.loadDeferredImages();
        this.complete();
        return;
      }

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.requestUpdate();
    }

    disconnectedCallback() {
      this.detach();

      if (this.raf) {
        cancelAnimationFrame(this.raf);
      }
    }

    detach() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    loadDeferredImages() {
      this.querySelectorAll('[data-srcset]').forEach((element) => {
        element.srcset = element.dataset.srcset;
        element.removeAttribute('data-srcset');
      });

      this.querySelectorAll('img[data-src]').forEach((image) => {
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
      });
    }

    requestUpdate() {
      if (this.raf || this.completed) return;

      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.update();
      });
    }

    update() {
      const rect = this.getBoundingClientRect();
      const scrollable = Math.max(1, rect.height - window.innerHeight);
      const progress = Math.min(1, Math.max(0, -rect.top / scrollable));
      const slideCount = Math.max(1, this.slides.length);
      const storyProgress = Math.min(1, progress / 0.56);
      const rawSlidePosition = storyProgress * (slideCount - 1);
      const activeIndex = Math.min(slideCount - 1, Math.floor(storyProgress * slideCount));
      const frameProgress = Math.min(1, progress / 0.34);
      const finalPhase = Math.min(1, Math.max(0, (progress - 0.48) / 0.18));
      const descriptionProgress = Math.min(1, Math.max(0, (progress - 0.62) / 0.08));
      const finalTitleScale = this.bouncyScale(finalPhase, window.matchMedia('(max-width: 749px)').matches);
      const transitionAmount = Math.min(1, Math.abs(rawSlidePosition - Math.round(rawSlidePosition)) / 0.5);
      const washOpacity = slideCount > 1 ? transitionAmount * 0.34 : 0;
      const startWidth = Math.min(800, window.innerWidth * 0.86);
      const mobileStartSize = Math.min(window.innerWidth * 0.62, window.innerHeight * 0.32);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const startHeight = isMobile ? mobileStartSize : Math.min(300, window.innerHeight * 0.38);
      const startFrameWidth = isMobile ? mobileStartSize : startWidth;
      const frameWidth = startFrameWidth + (window.innerWidth - startFrameWidth) * frameProgress;
      const frameHeight = startHeight + (window.innerHeight - startHeight) * frameProgress;
      const frameRadius = 999 * (1 - frameProgress) + this.endRadius() * frameProgress;
      const shadowOpacity = Math.max(0, 0.32 * (1 - frameProgress));
      const descriptionOffset = (1 - descriptionProgress) * 48;

      this.style.setProperty('--scroll-image-story-progress', progress.toFixed(4));
      this.style.setProperty('--scroll-image-story-frame-progress', frameProgress.toFixed(4));
      this.style.setProperty('--scroll-image-story-frame-width', `${frameWidth.toFixed(2)}px`);
      this.style.setProperty('--scroll-image-story-frame-height', `${frameHeight.toFixed(2)}px`);
      this.style.setProperty('--scroll-image-story-frame-radius', `${frameRadius.toFixed(2)}px`);
      this.style.setProperty('--scroll-image-story-shadow-opacity', shadowOpacity.toFixed(4));
      this.style.setProperty('--scroll-image-story-wash-opacity', washOpacity.toFixed(4));
      this.style.setProperty('--scroll-image-story-final-title-scale', finalTitleScale.toFixed(4));
      this.style.setProperty('--scroll-image-story-description-progress', descriptionProgress.toFixed(4));
      this.style.setProperty('--scroll-image-story-description-offset', `${descriptionOffset.toFixed(2)}px`);

      this.slides.forEach((slide, index) => {
        const distance = Math.abs((storyProgress * (slideCount - 1)) - index);
        const opacity = Math.max(0, 1 - distance * 1.9);
        const description = slide.querySelector('[data-scroll-image-story-description]');

        slide.style.setProperty('--scroll-image-story-slide-opacity', opacity.toFixed(4));
        slide.style.setProperty('--scroll-image-story-slide-offset', `${((1 - opacity) * 16).toFixed(2)}px`);

        if (description) {
          const descriptionVisibility = index === slideCount - 1 ? descriptionProgress : Math.max(0, opacity - 0.18);
          slide.style.setProperty('--scroll-image-story-description-progress', descriptionVisibility.toFixed(4));
          slide.style.setProperty('--scroll-image-story-description-offset', `${((1 - descriptionVisibility) * 48).toFixed(2)}px`);
        }
      });

      this.media.forEach((media, index) => {
        const distance = Math.abs((storyProgress * (slideCount - 1)) - index);
        const opacity = Math.max(0, 1 - distance * 2.2);
        media.style.setProperty('--scroll-image-story-media-opacity', opacity.toFixed(4));
      });

      this.setActive(activeIndex);
      this.updateDots(storyProgress, activeIndex);

      if (progress >= 0.78) {
        this.complete();
      }
    }

    bouncyScale(progress, isMobile = false) {
      const overshoot = isMobile ? 1.35 : 2.2;

      if (progress <= 0) return 0.42;
      if (progress < 0.58) return 0.42 + (progress / 0.58) * (overshoot - 0.42);

      return overshoot - (1 - Math.pow(1 - ((progress - 0.58) / 0.42), 3)) * (overshoot - 1);
    }

    endRadius() {
      return Number(getComputedStyle(this).getPropertyValue('--scroll-image-story-end-radius')) || 0;
    }

    setActive(activeIndex) {
      if (activeIndex > 0) {
        this.loadDeferredImages();
      }

      this.slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.media.forEach((media, index) => {
        media.classList.toggle('is-active', index === activeIndex);
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (this.completed) {
        this.slides.forEach((slide, index) => {
          slide.style.setProperty('--scroll-image-story-slide-opacity', index === activeIndex ? '1' : '0');
          slide.style.setProperty('--scroll-image-story-slide-offset', index === activeIndex ? '0px' : '16px');
          slide.style.setProperty('--scroll-image-story-description-progress', index === activeIndex ? '1' : '0');
          slide.style.setProperty('--scroll-image-story-description-offset', index === activeIndex ? '0px' : '48px');
        });

        this.media.forEach((media, index) => {
          media.style.setProperty('--scroll-image-story-media-opacity', index === activeIndex ? '1' : '0');
        });

        this.style.setProperty('--scroll-image-story-final-title-scale', '1');
      }
    }

    updateDots(storyProgress, activeIndex) {
      const slideCount = Math.max(1, this.dots.length);
      const scaled = storyProgress * slideCount;

      this.dots.forEach((dot, index) => {
        let dotProgress = scaled - index;
        dotProgress = Math.min(1, Math.max(0, dotProgress));

        const width = 12 + (40 - 12) * dotProgress;
        dot.style.setProperty('--scroll-image-story-dot-width', `${width.toFixed(2)}px`);
      });
    }

    complete() {
      if (this.completed) return;

      const sectionTop = window.scrollY + this.getBoundingClientRect().top;

      this.completed = true;
      this.detach();
      this.classList.add('is-complete');
      this.dots.forEach((dot) => {
        dot.removeAttribute('aria-disabled');
        dot.removeAttribute('tabindex');
      });

      this.style.setProperty('--scroll-image-story-progress', '1');
      this.style.setProperty('--scroll-image-story-frame-progress', '1');
      this.style.setProperty('--scroll-image-story-frame-width', '100vw');
      this.style.setProperty('--scroll-image-story-frame-height', '100svh');
      this.style.setProperty('--scroll-image-story-frame-radius', `${this.endRadius()}px`);
      this.style.setProperty('--scroll-image-story-shadow-opacity', '0');
      this.style.setProperty('--scroll-image-story-wash-opacity', '0');
      this.style.setProperty('--scroll-image-story-description-progress', '1');
      this.style.setProperty('--scroll-image-story-description-offset', '0px');
      this.style.setProperty('--scroll-image-story-final-title-scale', '1');
      this.setActive(this.slides.length - 1);
      this.updateDots(1, this.slides.length - 1);

      if (!new URLSearchParams(window.location.search).has('customer_posted')) {
        window.scrollTo({ top: sectionTop, behavior: 'instant' });
      }
    }
  }

  if (!customElements.get('scroll-image-story')) {
    customElements.define('scroll-image-story', ScrollImageStory);
  }

  } catch(e) { console.error(e); }
})();
})();
